import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { usePersonSchema } from './hooks/usePersonSchema';

export const PersonSchema: React.FC = () => {
	const {
		data: { schemaJson },
	} = usePersonSchema();

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
};
